"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.filename2varname = exports.stripQuotation = void 0;
function stripQuotation(str) {
    return str.replace(/^['"](.*?)['"]$/g, '$1');
}
exports.stripQuotation = stripQuotation;
function filename2varname(filename) {
    return string2varname(filename.replace(/(?=.*)\.\w+$/, '').replace(/\.st$/, ''));
}
exports.filename2varname = filename2varname;
function string2varname(str) {
    return str.replace(/[^0-9a-zA-Z_]/gm, '').replace(/^[^a-zA-Z_]+/gm, '');
}
//# sourceMappingURL=string.js.map